import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from "@/stores/user";
import { computed, ref, watch } from "vue";
import routesName from "@/utils/constants/routesName";
import logoSrc from "@/assets/images/logo.svg";
import logoShortSrc from "@/assets/icons/logo-short.svg";
import AppTextField from "@/components/common/AppTextField.vue";
import HeaderUserPanel from "@/components/HeaderUserPanel.vue";
import { useCoursesStore } from "@/stores/courses";
import { useDebounceFn } from "@vueuse/core";
import userMenuOptions from "@/utils/constants/userMenuOptions";
import { useRoute } from "vue-router";

interface MenuLink {
  title: string;
  routeName: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const courseStore = useCoursesStore();
const isLoggedIn = computed(() => !!userStore.accessToken);

const menuLinks: MenuLink[] = [
  {
    title: "Courses",
    routeName: routesName.coursesList,
  },
  {
    title: "Learning Centers",
    routeName: routesName.centersList,
  },
  {
    title: "Specialities",
    routeName: routesName.specialitiesList,
  },
];

const search = ref<string>("");
const setSearchValue = useDebounceFn((newV) => {
  courseStore.searchText = newV;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, 500);
watch(
  () => search.value,
  (newV) => {
    setSearchValue(newV);
  }
);

const isMenuOpen = ref<boolean>(false);
const toggleMenu = (): void => {
  isMenuOpen.value = !isMenuOpen.value;
};
watch(
  () => isMenuOpen.value,
  (newV) => {
    if (newV) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  },
  {
    immediate: true,
  }
);
const route = useRoute();
watch(
  () => route.name,
  (newV) => {
    if (newV !== routesName.coursesList) {
      search.value = "";
    }
    if (isMenuOpen.value) {
      toggleMenu();
    }
  }
);

const onMenuItem = (action: string): void => {
  toggleMenu();
  const actions: Record<string, () => void> = {
    onLogout: () => userStore.clear(),
  };
  const actionFunction = actions[action];
  if (actionFunction) {
    actionFunction();
  }
};

const __returned__ = { userStore, courseStore, isLoggedIn, menuLinks, search, setSearchValue, isMenuOpen, toggleMenu, route, onMenuItem, get useUserStore() { return useUserStore }, computed, ref, watch, get routesName() { return routesName }, get logoSrc() { return logoSrc }, get logoShortSrc() { return logoShortSrc }, AppTextField, HeaderUserPanel, get useCoursesStore() { return useCoursesStore }, get useDebounceFn() { return useDebounceFn }, get userMenuOptions() { return userMenuOptions }, get useRoute() { return useRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})